import { v4 as uuidv4 } from 'uuid';

export function FormSubmit(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormSubmit',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
